import { getFunctions, httpsCallable } from 'firebase/functions';
import { app } from '../firebase';

const functions = getFunctions(app, 'europe-west1');

export const sendInvitation = httpsCallable(functions, 'sendInvitation');
export const validateInvitation = httpsCallable(functions, 'validateInvitation');
export const markInvitationAsUsed = httpsCallable(functions, 'useInvitation');
export const getInvitations = httpsCallable(functions, 'getInvitations');
export const revokeInvitation = httpsCallable(functions, 'revokeInvitation');
